/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {

    init: function() {
      const _this = this;
      const donationDestinationGroup = document.querySelector( '.donation-destination-group' );
      const honoreeOptionsGroup = document.querySelector( '.honoree-options-group' );
      const donationsOptionsGroup = document.querySelector( '.donations-options-group' );
      const neededMost = document.querySelector( '#needed_most' );
      const honoreeNotificationGroup = document.querySelector( '.honoree-notification-group' );
      const honoreeLabel = document.querySelector( '.honoree-label' );
      const lltextarea = document.querySelector( '.textarea-ll' );
      lltextarea.classList.add( 'hidden' );
      honoreeLabel.classList.add( 'hidden' );
      document.forms.donation.frequency.forEach( ( radio ) => {
        radio.addEventListener( 'change', () => {
          switch ( document.forms.donation.frequency.value ) {
            case '3':
              donationDestinationGroup.style.display = 'flex';
              honoreeOptionsGroup.classList.remove( 'hidden' );
              honoreeNotificationGroup.classList.remove( 'hidden' );
              donationsOptionsGroup.classList.remove( 'hidden' );
              honoreeLabel.classList.remove( 'hidden' );
              lltextarea.classList.remove( 'hidden' );
              break;
            default:
              honoreeOptionsGroup.classList.add( 'hidden' );
              donationDestinationGroup.style.display = 'flex';
              honoreeNotificationGroup.classList.add( 'hidden' );
              honoreeLabel.classList.add( 'hidden' );
              lltextarea.classList.add( 'hidden' );
              break;
          }
        } );
      } );

      // document.forms.donation.donation_destination.forEach( ( radio ) => {
      //   radio.addEventListener( 'change', () => {
      //     switch ( document.forms.donation.donation_destination.value ) {
      //       case '2':
      //         donationsOptionsGroup.classList.remove( 'hidden' );
      //         break;
      //       default:
      //         donationsOptionsGroup.classList.add( 'hidden' );
      //         break;
      //     }
      //   } );
      // } );

      document.addEventListener( 'DOMContentLoaded', function() {
        setTimeout( function() {
          location.reload();
        }, 900000 );
      } );

      const amountInput = document.querySelector( '.donation-amount' );
      const amountError = document.querySelector( '.amount-error' );
      amountInput.addEventListener( 'focus', function( e ) {
        // check if number is less than 10000 and is not already a decimal
        if ( parseInt( e.target.value ) <= 10000 && e.target.value.indexOf( '.' ) === -1 ) {
          $formatvalue = '$' + e.target.value + '.00';
          amountInput.value = $formatvalue;
        } else {
          if ( e.target.value > 10000 ) {
            amountError.style.display = 'block';
          }
          if ( e.target.value.indexOf( '$' ) === -1 ) {
            amountInput.value = '$' + e.target.value;
          } else {
            amountInput.value = e.target.value;
          }
        }
      } );

      amountInput.addEventListener( 'keydown', function( e ) {
        // prevent shift key
        if ( e.shiftKey && e.which == 52 ) {
          e.preventDefault();
          return false;
        }
      } );

      amountInput.addEventListener( 'keyup', function( e ) {
        // check if number is less than 10000 and is not already a decimal
        if ( e.target.value.replace( '$', '' ) > 10000 ) {
          amountError.style.display = 'block';
        } else {
          amountError.style.display = 'none';
        }
      } );

      const creditCardInput = document.querySelector( '#credit_card' );
      const creditCardType = document.querySelector( '#credit_card_type' );
      const validationError = document.querySelector( '.credit-card-error' );
      const cvvInput = document.querySelector( '#credit_card_cvv' );

      cvvInput.addEventListener( 'keyup', function( e ) {
        if ( creditCardType.value == 1 ) {
          if ( e.target.value > 999 ) {
            console.log( e.target.value );
            e.preventDefault();
          }
        }
        if ( creditCardType.value == 3 ) {
          if ( cvvInput.value.length > 5 ) {
            e.preventDefualt();
          }
          cvvInput.setAttribute( 'max', 99999 );
        }
      } );

      creditCardInput.addEventListener( 'blur', function( e ) {
        validationError.style.display = 'none';
        validateCardNumber( e.target, creditCardType.value );
      } );

      creditCardType.addEventListener( 'change', function( e ) {
        validationError.style.display = 'none';
        // credit card type validation
        ccNumber = document.querySelector( '#credit_card' );
        if ( ccNumber.value ) {
          switch ( e.target.value ) {
            case '1':
              validateCardNumber( ccNumber, 1 );
              break;

            case '2':
              validateCardNumber( ccNumber, 2 );
              break;

            case '3':
              validateCardNumber( ccNumber, 3 );
              break;

            case '4':
              validateCardNumber( ccNumber, 4 );
              break;
          }
        }
      } );


      function validateCardNumber( ccNumber, type ) {
        $valid = false;
        if ( type == 1 ) {
          const cardno = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;
          if ( ccNumber.value.match( cardno ) ) {
            $valid = true;
          } else {
            $valid = false;
          }
        }
        if ( type == 2 ) {
          const cardno = /^(?:5[1-5][0-9]{14})$/;
          if ( ccNumber.value.match( cardno ) ) {
            $valid = true;
          } else {
            $valid = false;
          }
        }
        if ( type == 3 ) {
          const cardno = /^(?:3[47][0-9]{13})$/;
          if ( ccNumber.value.match( cardno ) ) {
            $valid = true;
          } else {
            $valid = false;
          }
        }
        if ( type == 4 ) {
          const cardno = /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/;
          if ( ccNumber.value.match( cardno ) ) {
            $valid = true;
          } else {
            $valid = false;
          }
        }

        if ( $valid ) {
          validationError.style.display = 'none';
        } else {
          validationError.style.display = 'block';
        }
        return $valid;
      }

      const countrySelection = document.querySelector( '#BILL_COUNTRY' );
      countrySelection.value = 'US';
      const usStateSelector = document.querySelector( '.billing_state' );
      const otherStateSelector = document.querySelector( '.bill_state_text' );
      if ( countrySelection.value !== 'US' ) {
        usStateSelector.style.display = 'none';
        otherStateSelector.style.display = 'block';
      } else {
        usStateSelector.style.display = 'block';
        otherStateSelector.style.display = 'none';
      }

      countrySelection.addEventListener( 'change', function( e ) {
        if ( e.target.value !== 'US' ) {
          usStateSelector.style.display = 'none';
          otherStateSelector.style.display = 'block';
        } else {
          usStateSelector.style.display = 'block';
          otherStateSelector.style.display = 'none';
        }
      } );

      const honoreeCountrySelection = document.querySelector( '#honoree_country' );
      honoreeCountrySelection.value = 'US';
      const honoreeUsStateSelector = document.querySelector( '.honoree_billing_state' );
      const honoroeeOtherStateSelector = document.querySelector( '.honoree_bill_state_text' );
      if ( honoreeCountrySelection.value !== 'US' ) {
        honoreeUsStateSelector.style.display = 'none';
        honoroeeOtherStateSelector.style.display = 'block';
      } else {
        honoreeUsStateSelector.style.display = 'block';
        honoroeeOtherStateSelector.style.display = 'none';
      }

      honoreeCountrySelection.addEventListener( 'change', function( e ) {
        if ( e.target.value !== 'US' ) {
          honoreeUsStateSelector.style.display = 'none';
          honoroeeOtherStateSelector.style.display = 'block';
        } else {
          honoreeUsStateSelector.style.display = 'block';
          honoroeeOtherStateSelector.style.display = 'none';
        }
      } );

      const form = document.querySelector( 'form.donation-form-skin' );
      form.addEventListener( 'keypress', function( e ) {
        const keyPressed = e.keyCode || e.which;
        if ( keyPressed === 13 ) {
          e.preventDefault();
          return false;
        }
      } );

      $( '.upay_submit' ).on( 'click', function( e ) {
        e.preventDefault();
        const $frequency = $( 'input[name="frequency"]:checked' ).val();
        let $amount = $( 'input[name="AMT"]' ).val();
        $amount = $amount.replace( '$', '' );

        const $donationDestination = $( 'input[name="donation_destination"]' ).val();
        const $selectedDonationDestination = $( '#donation-destination option:selected' ).val();

        const $honoreeSelectedOption = $( '#honoree-selection option:selected' ).val();
        const $honoreeName = $( 'input[name="honoree_name"]' ).val();
        const $honoreeNameNotify = $( 'input[name="honoree_name_notify"]' ).val();
        const $honoreeAddress = $( 'input[name="honoree_address"]' ).val();
        const $honoreeAddress2 = $( 'input[name="honoree_address2"]' ).val();
        const $honoreeCity = $( 'input[name="honoree_city"]' ).val();
        const $honoreeState = $( '#honoree_state option:selected' ).val();
        const $honoreeProvince = $( 'input[name="Honoree_Province"]' ).val();

        const $honoreeZip = $( 'input[name="honoree_zip"]' ).val();
        const $honoreeCountry = $( '#honoree_country option:selected' ).val();

        const $billName = $( 'input[name="BILL_NAME"]' ).val() + ' ' + $( 'input[name="BILL_NAME2"]' ).val();
        const $billStreet = $( 'input[name="BILL_STREET1"]' ).val();
        const $billStreet2 = $( 'input[name="BILL_STREET2"]' ).val();
        const $billCity = $( 'input[name="BILL_CITY"]' ).val();
        const $billState = $( '#BILL_STATE option:selected' ).val();
        const $billProvince = $( 'input[name="BILL_PROVINCE"]' ).val();
        const $billPostalCode = $( 'input[name="BILL_POSTAL_CODE"]' ).val();
        const $billCountry = $( 'input[name="BILL_COUNTRY"]' ).val();
        const $email = $( 'input[name="BILL_EMAIL_ADDRESS"]' ).val();
        const $phone = $( 'input[name="BILL_PHONE"]' ).val();
        const $emailUpdates = $( 'input[name="email_updates"]' ).val();
        const $llTextarea = $( '#ll_textarea' ).val();

        const $ccn = $( 'input[name="credit_card"]' ).val();
        const $ccExpirationMonth = $( 'input[name="credit_card_exp_mon"]' ).val();
        const $ccEexpirationYear = $( 'input[name="credit_card_exp_year"]' ).val();
        const $ccCCV = $( 'input[name="credit_card_cvv"]' ).val();
        const $ccType = $( 'input[name="credit_card_type"]' ).val();

        const $processFee = $( 'input[name="cover_processing_fee' ).val();

        let $llFrequency = 'false';
        if ( $frequency == 2 ) {
          $llFrequency = 1;
        }

        $.ajax( {
          type: 'POST',
          url: site_info.wpApiSettings.ll + 'uPay/generateSecureLinkTicket',
          data: {RECURRING_FREQUENCY: $llFrequency, Destination: $donationDestination, donation_destination: $selectedDonationDestination, honoree_name: $honoreeName, honoreeselection: $honoreeSelectedOption, BILL_NAME: $billName, BILL_STREET1: $billStreet, BILL_STREET2: $billStreet2, BILL_CITY: $billCity, BILL_STATE: $billState, BILL_POSTAL_CODE: $billPostalCode, BILL_COUNTRY: $billCountry, AMT: $amount, BILL_EMAIL_ADDRESS: $email, email_updates: $emailUpdates, Cover_Processing_Fee: $processFee, Phone: $phone, Honoree_Notify_Address: $honoreeAddress, Honoree_Notify_Address2: $honoreeAddress2, Honoree_Notify_City: $honoreeCity, Honoree_Notify_Country: $honoreeCountry, Honoree_Notify_Name: $honoreeNameNotify, Honoree_Notify_State: $honoreeState, Honoree_Notify_Zip: $honoreeZip, Honoree_Province: $honoreeProvince, BILL_PROVINCE: $billProvince, Honoree_Note: $llTextarea},
          beforeSend: function( xhr ) {
            xhr.setRequestHeader( 'X-WP-Nonce', site_info.wpApiSettings.nonce );
            xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
            doingAjax = true;
          },
          success: function( data ) {
            // console.log( data[0]._ticket[0] );
            $( '#TICKET' ).attr( 'value', data[0]._ticket[0] );
            if ( $( '#TICKET[value]' ).length > 0 ) {
              $( '.upay_submit_form' ).prop( 'disabled', false );
              $( 'form.donation-form-skin' ).submit();
            }
          },
          complete: function( jqXHR, status ) {
            doingAjax = false;
          },
        } );
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'donations-form', COMPONENT );
} )( app );

